import { BRAND } from "@/lib/constants";
import { MessageCircle, Phone, Sparkles } from "lucide-react";

/**
 * Strong, reusable CTA block — used at end of every SEO page.
 * Drives WhatsApp / call / quote actions.
 */
export default function CtaBlock({
  title = "Ready to design your invite?",
  subtitle = "Send us a message on WhatsApp — we reply within minutes.",
  prefilledMessage = "Hi InvitationWala, I'd like a custom digital wedding invitation.",
  testid = "cta-block",
}) {
  const waLink = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
    prefilledMessage
  )}`;
  return (
    <section
      data-testid={testid}
      className="relative py-20 md:py-24 my-10 md:my-14 px-6 md:px-12"
      style={{
        background:
          "linear-gradient(135deg, rgba(212,175,55,0.08) 0%, rgba(232,165,180,0.08) 100%)",
        border: "1px solid rgba(212,175,55,0.3)",
      }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-3 mb-5">
          <Sparkles size={14} className="text-[var(--iw-gold)]" />
          <span className="overline text-[var(--iw-gold)]">
            Free Consultation · 24-Hour Reply
          </span>
        </div>
        <h2
          className="font-serif-display text-[var(--iw-ivory)] text-3xl md:text-5xl leading-[1.05] tracking-tight"
          style={{ fontFamily: "Cormorant Garamond, serif" }}
        >
          {title}
        </h2>
        <p className="text-[var(--iw-muted)] mt-5 max-w-xl mx-auto leading-relaxed">
          {subtitle}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a
            href={waLink}
            target="_blank"
            rel="noreferrer noopener"
            className="btn-gold"
            data-testid={`${testid}-whatsapp`}
          >
            <MessageCircle size={14} />
            Book Free Consultation
          </a>
          <a
            href={`tel:${BRAND.whatsapp}`}
            className="btn-ghost-gold"
            data-testid={`${testid}-call`}
          >
            <Phone size={14} />
            {BRAND.whatsappDisplay}
          </a>
        </div>
        <p className="overline text-[var(--iw-faint)] mt-6">
          Custom Quote · Delivery in 24 Hours · Pan India &amp; NRI Worldwide
        </p>
      </div>
    </section>
  );
}
